<template>
    <div class="onboarding-review">
        <Nav />
        <div class="pt-5 mt-5 onboarding-width">
            <div class="mt-5 p-4 border add-rounded mx-3 mx-md-5">
                <div class="control-width mx-auto">
                    <h4 class="mb-4 font-weight-bold text-capitalize kova-text">Let's go ahead and make a job post for you</h4>   
                    <h6 class="mb-3 font-weight-bold">Job type</h6>            
                    <div class="container-fluid px-0 px-md-4 mb-5">
                        <div class="row my-5">
                            <div class="col-6 mx-auto px-1 px-sm-3 px-md-4">
                                <div class="border stage-box d-flex align-items-center mx-auto" @click="clickedFulltimeJob">
                                    <h6 class="kova-text font-weight-bolder mx-auto">Full-time Job</h6>
                                    <font-awesome-icon icon="check-circle" class="checked" v-if="fulltime"></font-awesome-icon>
                                </div>
                            </div>
                            <div class="col-6 mx-auto px-1 px-sm-3 px-md-4">
                                <div class="border stage-box d-flex align-items-center mx-auto" @click="clickedContractJob">
                                    <h6 class="kova-text font-weight-bolder mx-auto">Contract Job</h6>
                                    <font-awesome-icon icon="check-circle" class="checked" v-if="contract"></font-awesome-icon>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <hr />
                 <div class="control-width mx-auto">
                    <!-- <h4 class="mb-3 font-weight-bold kova-text">Let's go ahead and make a job post for you</h4> -->
                     <h6 class="font-weight-bold mb-4 mt-5 text-left">Select Job Role</h6>          

                    <a-select
                    class="w-100 mt-4 mb-5"
                    size="large"
                    v-model="title"
                    placeholder="What skills are required"
                    >
                    <a-select-option v-for="skill in skills" :key="skill">{{skill}}</a-select-option>
                    </a-select>   
                    
                                <h6 class="font-weight-bold mb-4 text-left">Provide job description below</h6> 
                                <vue-editor
                                id="editor"
                                useCustomImageHandler
                                :editorToolbar="customToolbar"
                                @image-added="handleImageAdded"
                                v-model="description"
                                placeholder="Job Description here"
                                ></vue-editor>
            
                    <!-- <a-input size="large" class="m-auto w-100" placeholder="Job description here" /> -->
                     
                </div>
                <hr />
                <div class="control-width mx-auto">
                    <h4 class="mb-3 font-weight-bolder kova-text">What Tech-stack requirement do you want your dev to have?</h4>            
                    <a-select
                        mode="multiple" class="w-100 mt-4 mb-5" size="large" v-model="stacks" placeholder="What skills are required">
                        <a-select-option v-for="stacklist in stacklists" :key="stacklist"
                        >{{stacklist}}</a-select-option
                        >
                    </a-select>
                </div>
              <br>
                <div class="control-width mx-auto">
                    <h6 class="mb-3 font-weight-bold text-left">
                    Select Job Specializations
                    </h6>
                    <a-select
                    mode="multiple"
                    class="w-100 mt-4 mb-5"
                    size="large"
                    v-model="specializations"
                    placeholder="Job specializations"
                    >
                    <a-select-option
                        v-for="specializationlist in specializationlists"
                        :key="specializationlist"
                        >{{ specializationlist }}</a-select-option
                    >
                    </a-select>
                </div>
                <hr />
                  <div class="control-width mx-auto">
                    <h4 class="mb-3 font-weight-bold kova-text">Job Duration</h4>
                    <div class="text-left">
                        <label for="dur1" class="radio text-left">
                            <input type="radio" name="rdo2" id="dur1" class="hidden"  value="1"
              v-model="duration" />
                            <span class="label"></span>3 months
                        </label><br />
                        
                        <label for="dur2" class="radio text-left">
                            <input type="radio" name="rdo2" id="dur2" class="hidden" value="2" v-model="duration"   />
                            <span class="label"></span>6 months
                        </label><br />
                        
                        <label for="dur3" class="radio text-left">
                            <input type="radio" name="rdo2" id="dur3" class="hidden" value="3" v-model="duration"  />
                            <span class="label"></span>1 year or more
                        </label><br />
                    </div>
                </div>
                <hr />
                <div class="control-width mx-auto">
                    <h4 class="mb-3 font-weight-bold kova-text">How many hours of commitment will you require from your developer?</h4> 
                    <div class="text-left">
                        <label for="opt1" class="radio text-left">
                            <input type="radio" name="rdo" id="opt1" class="hidden" value="1" v-model="commitment" @change="handleChange" />
                            <span class="label"></span>40 or more hrs/week (Full time)
                        </label><br />

                        <label for="opt2" class="radio text-left">
                            <input type="radio" name="rdo" id="opt2" class="hidden" value="2" v-model="commitment" @change="handleChange" />
                            <span class="label"></span>Less than 40 hrs/week (Part time)
                        </label><br />

                        <label for="opt3" class="radio text-left">
                            <input type="radio" name="rdo" id="opt3" class="hidden" value="3" v-model="commitment" @change="handleChange" />
                            <span class="label"></span>Hourly
                        </label><br />

                        <label for="opt4" class="radio text-left">
                            <input type="radio" name="rdo" id="opt4" class="hidden" value="4" v-model="commitment" @change="handleChange" />
                            <span class="label"></span>Don't know yet
                        </label><br />
                    </div>
                </div>
                <hr />
                 <div class="control-width mx-auto">
                    <h4 class="mb-3 font-weight-bold kova-text">Select expert level</h4>
                    <div class="text-left">
                        <label for="bud1" class="radio text-left">
                            <input type="radio" name="rdo4" id="bud1" class="hidden" value="1" v-model="complexity" @change="handleChange" />
                            <span class="label"></span>$5 - $20/hr (Junior)
                        </label><br />
                        
                        <label for="bud2" class="radio text-left">
                            <input type="radio" name="rdo4" id="bud2" class="hidden" value="2" v-model="complexity" @change="handleChange" />
                            <span class="label"></span>$10 - $40/hr (Intermediate)
                        </label><br />

                        <label for="bud3" class="radio text-left">
                            <input type="radio" name="rdo4" id="bud3" class="hidden" value="3" v-model="complexity" @change="handleChange"/>
                            <span class="label"></span>$15- $80/hr (Senior)
                        </label>
                    </div> 
                </div>
       
                <br>
                 <div class="control-width mx-auto">
                   <h6 class="mb-3 font-weight-bold text-left">
                            Input Talent Size
                        </h6>

                        <a-input-number
                            :precision="number"
                            size="large"
                            placeholder="1,2,3"
                            v-model="talent_size"
                            class="mx-auto mb-3 w-100"
                        />
                </div>
                <hr />

                <div class="control-width mx-auto">
                    <h4 class="mb-3 font-weight-bold kova-text">State your budget for this project</h4>
                 
                     <h6 class="mb-3 font-weight-bold text-left mt-4">Salary amount (per month)</h6>

                      <a-input-number
                        id="inputNumber"
                        v-model="budget"
                        :precision="number"
                        size="large"
                        placeholder="500 , 1000"
                        class="w-100 mb-3"
                        />
                        <br />

                        <h6 class="mb-3 font-weight-bold text-left mt-4">Salary currency</h6>

                        <a-select
                        mode="single"
                        class="w-100"
                        size="large"
                        placeholder="Please select your Currency"
                        v-model="currency"
                        >
                        <a-select-option v-for="item in currencies" :key="item">
                            {{
                            item
                            }}
                        </a-select-option>
                        </a-select>
                    <br />
                    <br />
                
                </div>
                <hr />

                <div class="control-width mx-auto">
                    <h4 class="mb-3 font-weight-bold kova-text">Company Bio</h4> 
                       <h6 class="mb-3 font-weight-bold text-left mt-4">Company name</h6>

                    <a-input size="large" placeholder="Kovatek" v-model="company_name" class="mx-auto mb-3" />
                    <br />
                    <h6 class="mb-3 font-weight-bold text-left mt-4">Location</h6>

                    <a-select
                    class="w-100 mb-3"
                    size="large"
                    placeholder="Please select your Country"
                    v-model="country"
                    >
                    <a-select-option v-for="item in countries" :key="item">{{item}}</a-select-option>
                    </a-select>
                    <br />
                </div>
                <hr />
                <div class="control-width mx-auto">
                    <h4 class="mb-3 font-weight-bold kova-text">Bio</h4> 
                       <h6 class="mb-3 font-weight-bold text-left mt-4">Full name</h6>

                    <a-input size="large" v-model="fullName" placeholder="John Doe"  class="mx-auto mb-3" />
                    <br />
                    <h6 class="mb-3 font-weight-bold text-left mt-4">Phone number</h6>

                    <a-input size="large" v-model="phone" placeholder class="mx-auto mb-3" />
                    <br />
                    <h6 class="mb-3 font-weight-bold text-left mt-4">Timezone</h6>

                    <a-select
                    class="w-100 mt-4 mb-5"
                    size="large"
                    v-model="timezone"
                    placeholder="Select Timezone"
                    >
          <a-select-option value="-12:00">(GMT -12:00) Eniwetok, Kwajalein</a-select-option>
            <a-select-option value="-11:00">(GMT -11:00) Midway Island, Samoa</a-select-option>
            <a-select-option value="-10:00">(GMT -10:00) Hawaii</a-select-option>
            <a-select-option value="-09:50">(GMT -9:30) Taiohae</a-select-option>
            <a-select-option value="-09:00">(GMT -9:00) Alaska</a-select-option>
            <a-select-option value="-08:00">(GMT -8:00) Pacific Time (US &amp; Canada)</a-select-option>
            <a-select-option value="-07:00">(GMT -7:00) Mountain Time (US &amp; Canada)</a-select-option>
            <a-select-option value="-06:00">(GMT -6:00) Central Time (US &amp; Canada), Mexico City</a-select-option>
            <a-select-option value="-05:00">(GMT -5:00) Eastern Time (US &amp; Canada), Bogota, Lima</a-select-option>
            <a-select-option value="-04:50">(GMT -4:30) Caracas</a-select-option>
            <a-select-option value="-04:00">(GMT -4:00) Atlantic Time (Canada), Caracas, La Paz</a-select-option>
            <a-select-option value="-03:50">(GMT -3:30) Newfoundland</a-select-option>
            <a-select-option value="-03:00">(GMT -3:00) Brazil, Buenos Aires, Georgetown</a-select-option>
            <a-select-option value="-02:00">(GMT -2:00) Mid-Atlantic</a-select-option>
            <a-select-option value="-01:00">(GMT -1:00) Azores, Cape Verde Islands</a-select-option>
            <a-select-option value="+00:00" >(GMT) Western Europe Time, London, Lisbon, Casablanca</a-select-option>
            <a-select-option value="+01:00">(GMT +1:00) Brussels, Copenhagen, Madrid, Paris, West Africa</a-select-option>
            <a-select-option value="+02:00">(GMT +2:00) Kaliningrad, South Africa</a-select-option>
            <a-select-option value="+03:00">(GMT +3:00) Baghdad, Riyadh, Moscow, St. Petersburg</a-select-option>
            <a-select-option value="+03:50">(GMT +3:30) Tehran</a-select-option>
            <a-select-option value="+04:00">(GMT +4:00) Abu Dhabi, Muscat, Baku, Tbilisi</a-select-option>
            <a-select-option value="+04:50">(GMT +4:30) Kabul</a-select-option>
            <a-select-option value="+05:00">(GMT +5:00) Ekaterinburg, Islamabad, Karachi, Tashkent</a-select-option>
            <a-select-option value="+05:50">(GMT +5:30) Bombay, Calcutta, Madras, New Delhi</a-select-option>
            <a-select-option value="+05:75">(GMT +5:45) Kathmandu, Pokhara</a-select-option>
            <a-select-option value="+06:00">(GMT +6:00) Almaty, Dhaka, Colombo</a-select-option>
            <a-select-option value="+06:50">(GMT +6:30) Yangon, Mandalay</a-select-option>
            <a-select-option value="+07:00">(GMT +7:00) Bangkok, Hanoi, Jakarta</a-select-option>
            <a-select-option value="+08:00">(GMT +8:00) Beijing, Perth, Singapore, Hong Kong</a-select-option>
            <a-select-option value="+08:75">(GMT +8:45) Eucla</a-select-option>
            <a-select-option value="+09:00">(GMT +9:00) Tokyo, Seoul, Osaka, Sapporo, Yakutsk</a-select-option>
            <a-select-option value="+09:50">(GMT +9:30) Adelaide, Darwin</a-select-option>
            <a-select-option value="+10:00">(GMT +10:00) Eastern Australia, Guam, Vladivostok</a-select-option>
            <a-select-option value="+10:50">(GMT +10:30) Lord Howe Island</a-select-option>
            <a-select-option value="+11:00">(GMT +11:00) Magadan, Solomon Islands, New Caledonia</a-select-option>
            <a-select-option value="+11:50">(GMT +11:30) Norfolk Island</a-select-option>
            <a-select-option value="+12:00">(GMT +12:00) Auckland, Wellington, Fiji, Kamchatka</a-select-option>
            <a-select-option value="+12:75">(GMT +12:45) Chatham Islands</a-select-option>
            <a-select-option value="+13:00">(GMT +13:00) Apia, Nukualofa</a-select-option>
            <a-select-option value="+14:00">(GMT +14:00) Line Islands, Tokelau</a-select-option>
        </a-select>
                    <br />
                </div>
                <hr />
                
                <div class="control-width mx-auto">
                    <h4 class="mb-3 font-weight-bold kova-text">Language</h4>
                    <a-select mode="multiple" class="w-100 mt-4" size="large" placeholder="Please select your Language" v-model="languages" >
                        <a-select-option v-for="languagelist in languagelists" :key="languagelist"
                        >{{languagelist}}</a-select-option>
                    </a-select>
                </div>
                <hr />
                <div class="control-width mx-auto">
                    <h4 class="mb-3 font-weight-bold kova-text">Visibility</h4>
                    <div class="text-left">
                        <div class="pl-0 py-1" style="min-width: 200px" >
                            <label class="checkbox-label mb-3">
                                <input type="checkbox" value="1" v-model="visibility"/>
                                <span class="checkbox-custom rectangular"></span><span class="mb-3 input-title ml-4 pl-2">Visible to everyone</span>
                            </label>
                        </div>
                        <div class="pl-0 py-1" style="min-width: 200px" >
                            <label class="checkbox-label mb-3">
                                <input type="checkbox" value="2" v-model="visibility"/>
                                <span class="checkbox-custom rectangular"></span><span class="mb-3 input-title ml-4 pl-2">Only Senior Developers</span>
                            </label>
                        </div>
                        <div class="pl-0 py-1" style="min-width: 200px" >
                            <label class="checkbox-label mb-3">
                                <input type="checkbox" value="3" v-model="visibility"/>
                                <span class="checkbox-custom rectangular"></span><span class="mb-3 input-title ml-4 pl-2">Only Intermediate Developers</span>
                            </label>
                        </div>
                        <div class="pl-0 py-1" style="min-width: 200px" >
                            <label class="checkbox-label mb-3">
                                <input type="checkbox" value="4" v-model="visibility"/>
                                <span class="checkbox-custom rectangular"></span><span class="mb-3 input-title ml-4 pl-2">Only Junior Developers</span>
                            </label>
                        </div>
                    </div> 

        <br />
        <br />

         <p class="text-danger font-weight-bolder my-2" v-if="error">
              {{ error }}
            </p>
          
               <div class="text-left" >
                   <div class="pl-0 py-1" style="min-width: 200px" >
                        <label class="checkbox-label">
                        <input type="checkbox" v-model="terms" />
                        <span class="checkbox-custom rectangular"></span><span class="mb-3 input-title ml-4 pl-2" style="font-size: 14px;">By registering you conﬁrm that you accept the <span class="font-weight-bolder">Terms and Conditions</span> and <span class="font-weight-bolder">Privacy Policy</span></span>
                    </label> 

                   </div>
                   
                    
               </div>
            
                    <div class="container-fluid px-0 px-md-4 mb-5 mt-5">
                        <div class="row">
                            <div class="col text-left">
                                <button class="btn-outline-kovatek py-2 px-4 px-sm-5 btn-rounded" v-on:click="goBack"> Cancel </button>
                            </div>
                            <div class="col text-right">
                                <button class="btn-kovatek py-2 px-4 px-sm-5 btn-rounded" @click="postProject"> {{ this.$route.query.edit ? 'Save' :'Post My Job' }}</button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="control-width mx-auto">
                </div>
                <hr /> -->
            </div>

          
        </div>
    </div>
</template>

<script>

import Nav from '@/components/Nav.vue';
import { VueEditor } from "vue2-editor";


export default {
    name: 'job-review',
    components: {
        Nav,
        VueEditor
    },
    data(){
        return {
            specializationlists:[
                'Adobe Software Engineers',
                'Agile QA Engineers',
                'Angular Developers',
                'ADK',
                'Android SDK',
                'API Development Specialists',
                'Access API',
                'ActionScrip',
                'AdMob',
                'AI Engineers',
                'Augmented Reality Developers',
                'Automation Developers',
                'AWS',
                'AWS Cloud Engineers',
                'AWS DevOps Engineers',
                'Back-End Developers',
                'Data Architects',
                'Blockchain Developers',
                'CI/CD Engineers',
                'C#',
                'C++',
                'C# .NET',
                'C++ .NET',
                'CSS',
                'CSS3',
                'D3.js',
                'ÐApp',
                'Dart',
                'Data Analysts',
                'Database Developers',
                'Data Engineers',
                'Data Modeling Experts',
                'Data Scientists',
                'Debugging',
                'Php',
                '.Net',
                'Wordpress dev',
                'Design Engineer',
                'DevOps Engineer',
                'Java Developer',
                'Dropbox',
                'DynsmoDB',
                'Eclipse',
                'eCommerce',
                'Elixir',
                'ERP',
                'Ethereum',
                'Ethereum Smart Contract',
                'Express.js',
                'ExtJS',
                'Payment Api',
                'Fintech',
                'Facebook Ads',
                'Facebook API',
                'Financial Software Developers',
                'Firebase',
                'Firmware Engineers',
                'Flutter',
                'Flux',
                'Fortran',
                'Freelance Developers',
                'Full-Stack Developers',
                'Full Stack Java',
                'Full Stack .NET',
                'Full Stack Node.js',
                'Full Stack PHP',
                'Full Stack Python',
                'Game Developers',
                'GatsbyJS',
                'Git',
                'GitFlow',
                'GitHub',
                'Gmail',
                'Go Engineers',
                'Golang',
                'Google Software Engineers',
                'Google AdWords',
                'Google Analytics',
                'Google API',
                'Google Cloud',
                'Google Cloud Platform',
                'GraphQL',
                'Haskell',
                'Healthcare Data Scientists',
                'Heroku',
                'Hive',
                'HTML5',
                'Hybrid App Developers',
                'Hyperledger',
                'IoT Developers',
                'JavaScript Consultants',
                'Javascript React',
                'Javascript Wordpress',
                'JIRA',
                'jQuery',
                'JRuby',
                'JSON Expert',
                'Kotlin',
                'Kubernetes Experts',
                'Linux',
                'Machine Learning Engineers',
                'MailChimp',
                'Mailgun',
                'MERN Stack',
                'Microservices',
                'MongoDB',
                'MS SQL Developers',
                'MySQL',
                'NestJS',
                '.NET',
                'NetBeans',
                '.NET Core',
                'Network Programmers',
                'Neural Network',
                'Next.js',
                'Node.js ',
                'Node.js Consulting Specialists',
                'Nuxt.js',
                'OAuth Experts',
                'Objective-C',
                'Object-Oriented Programming Experts',
                'Oracle',
                'Oracle SQL',
                'Payment Processing',
                'PayPal',
                'PHP',
                'PHP Laravel',
                'PHP MySQL',
                'PHP Unit Testing',
                'PHP Wordpress',
                'PostgreSQL',
                'PowerBI',
                'Python',
                'Python / C#',
                'QA Engineers',
                'QA Analysts',
                'QA Leads',
                'QA Managers',
                'Manual Testers',
                'QA Specialists',
                'QA Testers',
                'Ractive.js',
                'Raspberry Pi',
                'React.js',
                'React.js Development Consultants',
                'React Native',
                'React Node.js',
                'React Web',
                'Redux',
                'Responsive Web Developers',
                'REST API',
                'Ruby',
                'Ruby on Rails',
                'Rust',
                'SEO',
                'Shopify',
                'Shopify API',
                'Scrum',
                'Slack',
                'Smart Contract',
                'Software Architects',
                'Software Consultants',
                'Software Developers',
                'Software Engineers',
                'Solidity',
                'Spring',
                'Spring Boot',
                'SQL',
                'SQL CLR',
                'SQLite',
                'SQL Server',
                'Stripe Api',
                'Technical Writers',
                'Test Automation Engineers',
                'Test Automation Architects',
                'Test-Driven Development Experts',
                'Test Engineers',
                'Test Software Engineers',
                'Trading Software',
                'Trello',
                'Twilio',
                'Twitter',
                'Twitter Bootstrap',
                'TypeScript',
                'UI/UX',
                'UI',
                ' UX',
                ' and Front-End Developers',
                'Unit Testing Experts',
                'UX',
                'Vanilla JS',
                'Vue.js',
                'Vuetify.js',
                'WebObjects',
                'webOS',
                'Windows App',
                'WooCommerce',
                'WordPress',
                'WordPress Plugin',
                'Wordpress Specialists',
                'Wordpress Theme',
                'XHTML',
                'XML',
                'Zappier'
                ],
            stacklists: [
                'PHP', 'Nodejs', 'Django', 'Flask', 'Laravel', 'Java', 'C#', 'C++', '.NET', 
                'Ruby', 'Scala', 'Perl', 'Symfony', 'Spring', 'JSF', 'Others'
            ],
           countries: [
                "Afghanistan",
                "Albania",
                "Algeria",
                "American Samoa",
                "Andorra",
                "Angola",
                "Anguilla",
                "Antarctica",
                "Antigua and Barbuda",
                "Argentina",
                "Armenia",
                "Aruba",
                "Australia",
                "Austria",
                "Azerbaijan",
                "Bahamas (the)",
                "Bahrain",
                "Bangladesh",
                "Barbados",
                "Belarus",
                "Belgium",
                "Belize",
                "Benin",
                "Bermuda",
                "Bhutan",
                "Bolivia (Plurinational State of)",
                "Bonaire, Sint Eustatius and Saba",
                "Bosnia and Herzegovina",
                "Botswana",
                "Bouvet Island",
                "Brazil",
                "British Indian Ocean Territory (the)",
                "Brunei Darussalam",
                "Bulgaria",
                "Burkina Faso",
                "Burundi",
                "Cabo Verde",
                "Cambodia",
                "Cameroon",
                "Canada",
                "Cayman Islands (the)",
                "Central African Republic (the)",
                "Chad",
                "Chile",
                "China",
                "Christmas Island",
                "Cocos (Keeling) Islands (the)",
                "Colombia",
                "Comoros (the)",
                "Congo (the Democratic Republic of the)",
                "Congo (the)",
                "Cook Islands (the)",
                "Costa Rica",
                "Croatia",
                "Cuba",
                "Curaçao",
                "Cyprus",
                "Czechia",
                "Côte d'Ivoire",
                "Denmark",
                "Djibouti",
                "Dominica",
                "Dominican Republic (the)",
                "Ecuador",
                "Egypt",
                "El Salvador",
                "Equatorial Guinea",
                "Eritrea",
                "Estonia",
                "Eswatini",
                "Ethiopia",
                "Falkland Islands (the) [Malvinas]",
                "Faroe Islands (the)",
                "Fiji",
                "Finland",
                "France",
                "French Guiana",
                "French Polynesia",
                "French Southern Territories (the)",
                "Gabon",
                "Gambia (the)",
                "Georgia",
                "Germany",
                "Ghana",
                "Gibraltar",
                "Greece",
                "Greenland",
                "Grenada",
                "Guadeloupe",
                "Guam",
                "Guatemala",
                "Guernsey",
                "Guinea",
                "Guinea-Bissau",
                "Guyana",
                "Haiti",
                "Heard Island and McDonald Islands",
                "Holy See (the)",
                "Honduras",
                "Hong Kong",
                "Hungary",
                "Iceland",
                "India",
                "Indonesia",
                "Iran (Islamic Republic of)",
                "Iraq",
                "Ireland",
                "Isle of Man",
                "Israel",
                "Italy",
                "Jamaica",
                "Japan",
                "Jersey",
                "Jordan",
                "Kazakhstan",
                "Kenya",
                "Kiribati",
                "Korea (the Democratic People's Republic of)",
                "Korea (the Republic of)",
                "Kuwait",
                "Kyrgyzstan",
                "Lao People's Democratic Republic (the)",
                "Latvia",
                "Lebanon",
                "Lesotho",
                "Liberia",
                "Libya",
                "Liechtenstein",
                "Lithuania",
                "Luxembourg",
                "Macao",
                "Madagascar",
                "Malawi",
                "Malaysia",
                "Maldives",
                "Mali",
                "Malta",
                "Marshall Islands (the)",
                "Martinique",
                "Mauritania",
                "Mauritius",
                "Mayotte",
                "Mexico",
                "Micronesia (Federated States of)",
                "Moldova (the Republic of)",
                "Monaco",
                "Mongolia",
                "Montenegro",
                "Montserrat",
                "Morocco",
                "Mozambique",
                "Myanmar",
                "Namibia",
                "Nauru",
                "Nepal",
                "Netherlands (the)",
                "New Caledonia",
                "New Zealand",
                "Nicaragua",
                "Niger (the)",
                "Nigeria",
                "Niue",
                "Norfolk Island",
                "Northern Mariana Islands (the)",
                "Norway",
                "Oman",
                "Pakistan",
                "Palau",
                "Palestine, State of",
                "Panama",
                "Papua New Guinea",
                "Paraguay",
                "Peru",
                "Philippines (the)",
                "Pitcairn",
                "Poland",
                "Portugal",
                "Puerto Rico",
                "Qatar",
                "Republic of North Macedonia",
                "Romania",
                "Russian Federation (the)",
                "Rwanda",
                "Réunion",
                "Saint Barthélemy",
                "Saint Helena, Ascension and Tristan da Cunha",
                "Saint Kitts and Nevis",
                "Saint Lucia",
                "Saint Martin (French part)",
                "Saint Pierre and Miquelon",
                "Saint Vincent and the Grenadines",
                "Samoa",
                "San Marino",
                "Sao Tome and Principe",
                "Saudi Arabia",
                "Senegal",
                "Serbia",
                "Seychelles",
                "Sierra Leone",
                "Singapore",
                "Sint Maarten (Dutch part)",
                "Slovakia",
                "Slovenia",
                "Solomon Islands",
                "Somalia",
                "South Africa",
                "South Georgia and the South Sandwich Islands",
                "South Sudan",
                "Spain",
                "Sri Lanka",
                "Sudan (the)",
                "Suriname",
                "Svalbard and Jan Mayen",
                "Sweden",
                "Switzerland",
                "Syrian Arab Republic",
                "Taiwan",
                "Tajikistan",
                "Tanzania, United Republic of",
                "Thailand",
                "Timor-Leste",
                "Togo",
                "Tokelau",
                "Tonga",
                "Trinidad and Tobago",
                "Tunisia",
                "Turkey",
                "Turkmenistan",
                "Turks and Caicos Islands (the)",
                "Tuvalu",
                "Uganda",
                "Ukraine",
                "United Arab Emirates (the)",
                "United Kingdom of Great Britain and Northern Ireland (the)",
                "United States Minor Outlying Islands (the)",
                "United States of America (the)",
                "Uruguay",
                "Uzbekistan",
                "Vanuatu",
                "Venezuela (Bolivarian Republic of)",
                "Viet Nam",
                "Virgin Islands (British)",
                "Virgin Islands (U.S.)",
                "Wallis and Futuna",
                "Western Sahara",
                "Yemen",
                "Zambia",
                "Zimbabwe"
          ],
            showInput: false,
            error: "",
            response: "",
            skills: [
                "Android Developer",
                "IOS Developer",
                "Data Engineer",
                "Front-end Engineer",
                "Back-end Engineer",
                "UI/UX Designer",
                "Artificial Intelligence",
                "Blockchain Engineer",
                "DevOps Engineer"
            ],
            languagelists: ["English", "French"],
            currencies: ["USD", "NGN", "GBP"],
            languages: [],
            visibility: [],
            visibilities: ['Visible to everyone', 'Only Senior Developers', 'Only Intermediate Developers', 'Only Junior Developers'],
            budget: this.$store.state.fcjob.fcjobData.budget,
            currency: this.$store.state.fcjob.fcjobData.currency,
            stacks: this.$store.state.fcjob.fcjobData.skills,
            duration: this.$store.state.fcjob.fcjobData.duration,
            fullName: this.$store.state.fcjob.fcjobData.fullName,
            company_name: this.$store.state.fcjob.fcjobData.company_name,
            commitment: this.$store.state.fcjob.fcjobData.commitment,
            fulltime: this.$store.state.client.clientData.type === 2 ? true : false ,
            contract: this.$store.state.client.clientData.type === 3 ? true : false,
            type: this.$store.state.client.clientData.type,
            country: this.$store.state.fcjob.fcjobData.country,
            phone: this.$store.state.fcjob.fcjobData.phone,
            complexity : this.$store.state.fcjob.fcjobData.complexity,
            title: this.$store.state.fcjob.fcjobData.title,
            description: this.$store.state.fcjob.fcjobData.description,
            timezone: this.$store.state.fcjob.fcjobData.timezone,
            talent_size: this.$store.state.fcjob.fcjobData.talent_size,
            specializations: this.$store.state.fcjob.fcjobData.specializations,
            terms: false,
            customToolbar: [
                ["bold", "italic", "underline"],
                [{ list: "ordered" }, { list: "bullet" }],
                ["code-block"]
            ]
        }
    },
    methods: {
        goBack(){
            this.$router.go(-1)
        },
        next(){
            this.$router.push('payment-budget')
        },
        skip(){
            this.$router.push('onboarding/description')
        },
        clickedFulltimeJob(){
            this.fulltimeJob = true;
            this.contractJob = false;
            let projectState = this.fulltimeJob ? 2 : this.contractJob ? 3 : '';
            this.$store.state.client.clientData.type = projectState
        },
        clickedContractJob(){
             this.contractJob = true;
            this.fulltimeJob = false;
            let projectState = this.contractJob ? 3 : this.fulltimeJob ? 2 : '';
            this.$store.state.client.clientData.type = projectState
        },
        devNoChange(e){
            if(e.target.value === "more"){
                return this.showInput = true;
            }
            return this.showInput = false;
        },
        handleChange(){
            this.$store.state.projects.title = this.title;
            this.$store.state.projects.description = this.htmlForEditor;
            this.$store.state.projects.skills = this.skill;
            this.$store.state.projects.specifications = this.specifications;
            this.$store.state.projects.commitment = this.commitment;
            this.$store.state.projects.jobType = this.jobType;
            this.$store.state.projects.duration = this.duration;
            this.$store.state.projects.talent_size = this.talentSize;
            this.$store.state.projects.complexity = this.complexity;
            this.$store.state.projects.devSkills = this.devSkills
        },
        postProject(){

            if(!this.terms) return this.error = 'Please agree to the terms of conditions!';
            this.error = null;
            /* const projectData = {
                type: this.$store.state.client.clientData.type,
                title: this.$store.state.fcjob.fcjobData.title,
                description: this.$store.state.fcjob.fcjobData.description,
                stacks: this.$store.state.fcjob.fcjobData.stacks,
                skills: this.$store.state.fcjob.fcjobData.stacks,
                duration: parseInt(this.$store.state.fcjob.fcjobData.duration),
                commitment: parseInt(this.$store.state.fcjob.fcjobData.commitment),
                complexity : parseInt(this.$store.state.fcjob.fcjobData.complexity),
                budget: this.$store.state.fcjob.fcjobData.budget,
                currency: this.$store.state.fcjob.fcjobData.currency,
                company_name: this.$store.state.fcjob.fcjobData.company_name,
                location: this.$store.state.fcjob.fcjobData.location,
                fullName: this.$store.state.fcjob.fcjobData.fullName,
                phone: this.$store.state.fcjob.fcjobData.phone,
                timezone: this.$store.state.fcjob.fcjobData.timezone,
                talent_size: this.$store.state.fcjob.fcjobData.talent_size,
                specializations: this.$store.state.fcjob.fcjobData.specializations,
                languages: this.languages,
                avatar: this.$store.state.fcjob.fcjobData.avatar,
                visibility: 2
            } */

            const formData = new FormData();
            formData.append('type', this.$store.state.client.clientData.type);
            formData.append('title', this.$store.state.fcjob.fcjobData.title);
            formData.append('description', this.$store.state.fcjob.fcjobData.description);
            formData.append('stacks', this.$store.state.fcjob.fcjobData.stacks);
            let skillsArray = this.$store.state.fcjob.fcjobData.skills;
            for (var i = 0; i < skillsArray.length; i++) {
                formData.append('skills', skillsArray [i]);
            }
            formData.append('duration', parseInt(this.$store.state.fcjob.fcjobData.duration));
            formData.append('commitment', parseInt(this.$store.state.fcjob.fcjobData.commitment));
            formData.append('complexity', parseInt(this.$store.state.fcjob.fcjobData.complexity));
            formData.append('budget', this.$store.state.fcjob.fcjobData.budget);
            formData.append('currency', this.$store.state.fcjob.fcjobData.currency);
            formData.append('company_name', this.$store.state.fcjob.fcjobData.company_name);
            formData.append('country', this.$store.state.fcjob.fcjobData.country);
            formData.append('city', this.$store.state.fcjob.fcjobData.state);
            formData.append('fullName', this.$store.state.fcjob.fcjobData.fullName);
            formData.append('phone', this.$store.state.fcjob.fcjobData.phone);
            formData.append('timezone', this.$store.state.fcjob.fcjobData.timezone);
            formData.append('talent_size', this.$store.state.fcjob.fcjobData.talent_size);
            let specializationsArray = this.$store.state.fcjob.fcjobData.specializations;
            for (var j = 0; j < specializationsArray.length; j++) {
                formData.append('specializations', specializationsArray [j]);
            }
            let languagesArray = this.languages;
            for (var k = 0; k < languagesArray.length; k++) {
                formData.append('languages', languagesArray [k]);
            }
            formData.append('avatar', this.$store.state.fcjob.fcjobData.avatar);
            formData.append('visibility', 2);
            

           
            if(this.$route.query.edit){
                this.$store.dispatch('projects/updateProject', { projectData: formData, projectId: this.$route.query.projectId })
                .then(resp => {
                   this.response = resp
                    this.$router.push("my-projects")
                })
                .catch(err => {
                    this.error = err
                })
            } else {
                this.$store.dispatch('projects/postProject', formData )
                .then(resp => {
                   this.response = resp;
                    this.$router.push("my-projects")
                })
                .catch(err => {
                 this.error = err;
                })
            }
            
        }
    },
    mounted(){
        this.$http({
            method: 'GET',
            url:'https://ajayakv-rest-countries-v1.p.rapidapi.com/rest/v1/all',
            headers: {
                "x-rapidapi-host": "ajayakv-rest-countries-v1.p.rapidapi.com","x-rapidapi-key": "6ca124e468msh22c5cc821adbce1p14a23ejsn2364b404d00d"
            }
        }).then((response) => {
            this.countries = response.data
            // console.log(response.data)
        });
    }
}
</script>

<style scoped>
.onboarding-width{
   max-width: 1200px;
   margin: auto;
}

.control-width{
    width: 600px;
}
.stage-box{
    height: 90px;
    width: 180px;
    border-radius: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}
.stage-box:hover{
    background-color: #f1f1f1
}
.checked{
    position: absolute;
    left: 190px;
    font-size: 35px;
    bottom: 45px;
    color: #4BB38E;
}
.input-title{
    font-size: 15px;
}
@media (min-width: 768px) and (max-width: 991px){
   
}
@media (max-width: 767px){
    .control-width{
        width:500px;
    }
}
@media (max-width: 550px){
    .control-width{
        width:98%;
    }
    .stage-box{
        height:75px;
        width: 140px;
        border-radius: 20px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
    }
    .checked{
        position: absolute;
        left: 135px;
        font-size: 30px;
        bottom: 45px;
        color: #4BB38E;
    }
}
</style>